import mitt from "mitt";

export function SuccessfulModalController() {
    this.busModal = new mitt();
    this.callbackOk = null;
    this.callbackClose = null;
    this.msg = '';
    this.title = '';
    this.btnOk = '';
    this.btnApply = '';
    this.clearModal = function() {
        this.msg = '';
        this.title = '';
        this.btnOk = '';
        this.btnApply = '';
        return this;
    };

    this.setMsg = function(msg) {
        this.msg = msg;
        return this;
    };

    this.setTitle = function(title) {
        this.title = title;
        return this;
    };

    this.setBtnOk = function(text) {
        this.btnOk = text;
        return this;
    };

    this.setBtnApply = function(text) {
        this.btnApply = text;
        return this;
    };

    this.show = function() {
        this.busModal.emit("show", {
            title: this.title,
            msg: this.msg,
            btnOk: this.btnOk,
            btnApply: this.btnApply,
        });
        return this;
    };

    this.hide = function() {
        this.busModal.emit("hide");
        return this;
    };

    this.onClickOk = function(callback) {
        this.callbackOk = callback;
        return this;
    };

    this.onClose = function(callback) {
        this.callbackClose = callback;
        return this;
    };

    this.sendCallbackOk = function(data) {
        if (typeof this.callbackOk === "function") {
            this.callbackOk(data);
        }
    }

    this.sendCallbackClose = function() {
        if (typeof this.callbackClose === "function") {
            this.callbackClose();
        }
    }
}